import CustomFieldsAdmin from '@/pages/customFieldAdmin/CustomFieldsAdmin.page'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/custom-fields')({
  component: () => <CustomFieldsAdminLayout />,
  // component: () => <IFramePage url="custom-fields-admin.html" />,
})

const CustomFieldsAdminLayout = () => {
  return (
    <>
      <CustomFieldsAdmin />
      <Outlet />
    </>
  )
}
